/****************************************************************************************
 * File Name    : ToolWorkSheet.vue
 * Function     : 치공구외 일지작성 (실제 데이터 입력)
 * Author       : 
 * Description  : 치공구 점검 일지 작성 및 관리
 * Modification Log
 * ======================================================================================
 * Ver  Date        	Author     	Modification
 * ======================================================================================
   1.0  2026.02.17  	        	Create
****************************************************************************************/
<template>
    <div>
        <a-row :gutter="16">
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box">
                    <PageHeader title="치공구 점검 일지 작성" />
                </div>
            </a-col>
            <a-col class="gutter-row" :span="12">
                <div class="gutter-box div_action">
                    <a-select v-model="selectedTemplate" placeholder="템플릿 선택" style="width: 200px; margin-right: 10px;" :key="templateList.length">
                        <a-select-option v-for="template in templateList" :key="template.id" :value="template.id">
                            {{ template.name }}
                        </a-select-option>
                    </a-select>
                    <span class='icon_button' @click="loadTemplate()">
                        <a-tag color="#2980B9" style="cursor:pointer;">
                            <a-icon type="plus-circle" /> 불러오기
                        </a-tag>
                    </span>
                </div>
            </a-col>
        </a-row>
        <a-divider type='horizontal' />
        
        <a-space align="end">
            <a-statistic title="작성중" :value="workingCount" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="question-circle" />
                </template>
            </a-statistic>
            <a-statistic title="작성완료" :value="completedCount" style="margin-right: 50px">
                <template #prefix>
                    <a-icon type="exclamation-circle" />
                </template>
            </a-statistic>
        </a-space>
        <p/>
        <a-progress type='line' :percent="90" strokeColor='#C7C6C6'/>
        <p/>
        
        <!-- 작성중 목록 -->
        <a-table :columns="columns" size="small" :bordered="false" :data-source="workingData" :scroll="{ x: 0, y: '37vh' }">
            <span slot="tags" slot-scope="tags">
                <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ red: (tag === '작성중'), green: (tag === '작성완료') }">
                    {{ tag.toUpperCase() }}
                </a-tag>
            </span>
            <span slot="name" slot-scope="text">{{ text }}</span>
            <span slot="action" slot-scope="record">
                <span style='cursor:pointer' @click="handlerToEdit(record.key)"><a-icon type="edit" /> Edit</span>
                <a-divider type="vertical" />
                <span style='cursor:pointer' @click="handlerToDelete(record.key)"><a-icon type="delete" /> Delete</span>
            </span>
        </a-table>
        <p/>
        
        <!-- 작성완료 목록 -->
        <a-form class="" layout="vertical">
            <a-card>
                <a-space align="end">
                    치공구 점검 일지 조회
                    <a-input default-value="" v-model="filterCS">
                        <a-select slot="addonAfter" default-value="라인명" v-model="filterField">
                            <a-select-option value="라인명">라인명</a-select-option>
                            <a-select-option value="생산모델">생산모델</a-select-option>
                            <a-select-option value="작성자">작성자</a-select-option>
                        </a-select>
                    </a-input>
                    일자 조회
                    <date-picker v-model="filterDateStartCS" valueType="format" style="width:120px;"></date-picker> ~
                    <date-picker v-model="filterDateEndCS" valueType="format" style="width:120px;"></date-picker>
                    <a-button type="primary" :ghost="true" @click="filterCSList">검색</a-button>
                    <a-button @click="resetCSList">초기화</a-button>
                </a-space>
                <p/>
                <a-table :columns="columns2" size="small" :bordered="false" :data-source="completedData" :pagination="pagination" :scroll="{ x: 0, y: '57vh' }" @change="handleTableChange">
                    <span slot="tags" slot-scope="tags">
                        <a-tag v-for="tag in tags" :key="tag" class="state-btn" :class="{ red: (tag === '작성중'), green: (tag === '작성완료') }">
                            {{ tag.toUpperCase() }}
                        </a-tag>
                    </span>
                    <span slot="name" slot-scope="text">{{ text }}</span>
                    <span slot="action" slot-scope="record">
                        <span style='cursor:pointer' @click="handlerToEdit(record.key)"><a-icon type="edit" /> Edit</span>
                        <a-divider type="vertical" />
                    </span>
                </a-table>
            </a-card>
        </a-form>

        <!-- 일지 작성 Drawer -->
        <a-drawer 
            title="치공구 점검 일지 작성" 
            placement="right" 
            :closable="true" 
            :visible="flagForDrawer" 
            @close="handlerForCloseDrawer" 
            width="100%"
        >
            <a-form layout="vertical">
                <!-- 기본정보 -->
                <a-card title="기본정보" :bordered="false" style="margin-bottom: 16px;">
                    <a-row :gutter="16">
                        <a-col :span="8">
                            <a-form-item label="라인명">
                                <a-input v-model="formData.basicInfo.lineName" placeholder="라인명" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="라인장">
                                <a-select v-model="formData.basicInfo.writer" placeholder="라인장 선택" style="width:100%;">
                                    <a-select-option v-for="m in managerList" :key="m.manager_seq" :value="m.name">{{ m.name }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-item label="작성일자">
                                <a-input :value="formData.basicInfo.date" :read-only="true" />
                            </a-form-item>
                        </a-col>
                    </a-row>
                </a-card>

                <!-- 드라이버 토크 관리 -->
                <a-card title="드라이버 토크 관리" :bordered="false" style="margin-bottom: 16px;">
                    <a-table 
                        :columns="driverTorqueWorkColumns" 
                        :data-source="formData.driverTorque" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="measuredValue" slot-scope="text, record">
                            <a-input v-model="record.measuredValue" placeholder="측정값" />
                        </template>
                        <template slot="measuredBy" slot-scope="text, record">
                            <a-input v-model="record.measuredBy" placeholder="측정자" />
                        </template>
                        <template slot="exchangeNo" slot-scope="text, record">
                            <a-input v-model="record.exchangeNo" placeholder="교환번호" />
                        </template>
                        <template slot="result" slot-scope="text, record">
                            <a-select v-model="record.result" style="width: 100%">
                                <a-select-option value="">&nbsp;</a-select-option>
                                <a-select-option value="OK">OK</a-select-option>
                                <a-select-option value="NG">NG</a-select-option>
                            </a-select>
                        </template>
                    </a-table>
                </a-card>

                <!-- 계측기 관리 -->
                <a-card title="계측기 관리" :bordered="false" style="margin-bottom: 16px;">
                    <a-table 
                        :columns="measurementWorkColumns" 
                        :data-source="formData.measurement" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <span slot="inspectorHeader">
                            검사자&nbsp;
                            <a-checkbox v-model="autoFillInspector" @change="onAutoFillInspectorChange" style="font-weight:normal;font-size:12px;">
                                자동채우기
                            </a-checkbox>
                        </span>
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="measuredValue" slot-scope="text, record">
                            <a-input v-model="record.measuredValue" placeholder="측정값" />
                        </template>
                        <template slot="result" slot-scope="text, record">
                            <a-select v-model="record.result" style="width: 100%">
                                <a-select-option value="">&nbsp;</a-select-option>
                                <a-select-option value="OK">OK</a-select-option>
                                <a-select-option value="NG">NG</a-select-option>
                            </a-select>
                        </template>
                        <template slot="inspector" slot-scope="text, record, index">
                            <a-input
                                v-model="record.inspector"
                                placeholder="검사자"
                                @input="onInspectorInput(index)"
                            />
                        </template>
                        <template slot="memo" slot-scope="text, record">
                            <a-input v-model="record.memo" placeholder="메모" />
                        </template>
                    </a-table>
                </a-card>

                <!-- 가스세이버 관리 -->
                <a-card title="가스세이버 관리" :bordered="false" style="margin-bottom: 16px;">
                    <a-table 
                        :columns="gasSaverWorkColumns" 
                        :data-source="formData.gasSaver" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="measuredValue" slot-scope="text, record">
                            <a-input v-model="record.measuredValue" placeholder="측정값" />
                        </template>
                        <template slot="result" slot-scope="text, record">
                            <a-select v-model="record.result" style="width: 100%">
                                <a-select-option value="">&nbsp;</a-select-option>
                                <a-select-option value="OK">OK</a-select-option>
                                <a-select-option value="NG">NG</a-select-option>
                            </a-select>
                        </template>
                    </a-table>
                </a-card>

                <!-- 검사장치 관리 -->
                <a-card title="검사장치 관리" :bordered="false" style="margin-bottom: 16px;">
                    <a-table 
                        :columns="inspectionWorkColumns" 
                        :data-source="formData.inspection" 
                        :pagination="false"
                        size="small"
                        bordered
                    >
                        <template slot="no" slot-scope="text, record, index">
                            {{ index + 1 }}
                        </template>
                        <template slot="result" slot-scope="text, record">
                            <a-select v-model="record.result" style="width: 100%">
                                <a-select-option value="">&nbsp;</a-select-option>
                                <a-select-option value="OK">OK</a-select-option>
                                <a-select-option value="NG">NG</a-select-option>
                            </a-select>
                        </template>
                    </a-table>
                </a-card>

                <a-card
                    v-for="section in formData.gasFilling"
                    :key="section.target"
                    :bordered="false"
                    style="margin-bottom: 16px;"
                >
                    <template slot="title">
                        <span>GAS 충진 M/C ({{ section.target }})</span>
                        <span style="margin-left: 24px; font-weight: normal; font-size: 14px;">
                            S/W 상태
                            <a-select
                                v-model="section.swStatus"
                                style="width: 120px; margin-left: 8px;"
                                placeholder="선택"
                                allow-clear
                            >
                                <a-select-option value="">&nbsp;</a-select-option>
                                <a-select-option value="OK">OK</a-select-option>
                                <a-select-option value="NG">NG</a-select-option>
                            </a-select>
                        </span>
                    </template>
                    <a-table
                        :columns="gasFillingWorkColumns"
                        :data-source="section.rows"
                        :pagination="false"
                        size="small"
                        bordered
                        :row-key="record => `${section.target}-${record.shift}`"
                    >
                        <template slot="freonPressure" slot-scope="text, record">
                            <a-input v-model="record.freonPressure" placeholder="레온 압력" />
                        </template>
                        <template slot="vacuumLevel" slot-scope="text, record">
                            <a-input v-model="record.vacuumLevel" placeholder="진공도" />
                        </template>
                        <template slot="freonTemperature" slot-scope="text, record">
                            <a-input v-model="record.freonTemperature" placeholder="프레온 온도" />
                        </template>
                        <template slot="settingValue" slot-scope="text, record">
                            <a-input v-model="record.settingValue" placeholder="셋팅" />
                        </template>
                        <template slot="chargeAmount" slot-scope="text, record">
                            <a-input v-model="record.chargeAmount" placeholder="충진량" />
                        </template>
                        <template slot="checkResult" slot-scope="text, record">
                            <a-select v-model="record.checkResult" style="width: 100%" placeholder="점검결과">
                                <a-select-option value="">&nbsp;</a-select-option>
                                <a-select-option value="OK">OK</a-select-option>
                                <a-select-option value="NG">NG</a-select-option>
                            </a-select>
                        </template>
                    </a-table>
                </a-card>

                <a-divider />
                <div style="text-align: center;">
                    <a-button @click="handlerForCloseDrawer" style="margin-right: 8px;">취소</a-button>
                    <a-button type="default" @click="handleSaveTemp" style="margin-right: 8px;">임시저장</a-button>
                    <a-button type="primary" @click="handleSaveComplete">작성완료</a-button>
                </div>
            </a-form>
        </a-drawer>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import PageHeader from "../components/PageHeader.vue";

const columns = [
    { title: '상태', dataIndex: 'tags', key: 'tags', scopedSlots: { customRender: 'tags' }, width: 100 },
    { title: '라인명', dataIndex: 'lineName', key: 'lineName' },
    { title: '라인장', dataIndex: 'writer', key: 'writer' },
    { title: '최종수정일', dataIndex: 'updated', key: 'updated' },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 200 },
];

const columns2 = [
    { title: '상태', dataIndex: 'tags', key: 'tags', scopedSlots: { customRender: 'tags' }, width: 100 },
    { title: '라인명', dataIndex: 'lineName', key: 'lineName' },
    { title: '라인장', dataIndex: 'writer', key: 'writer' },
    { title: '작성일자', dataIndex: 'date', key: 'date' },
    { title: '최종수정일', dataIndex: 'updated', key: 'updated' },
    { title: '관리', key: 'action', scopedSlots: { customRender: 'action' }, width: 150 },
];

const driverTorqueWorkColumns = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 60 },
    { title: '공정명', dataIndex: 'processName', key: 'processName' },
    { title: '공구분류', dataIndex: 'toolType', key: 'toolType', width: 100 },
    { title: '관리번호', dataIndex: 'managementNo', key: 'managementNo' },
    { title: '기준', dataIndex: 'standard', key: 'standard' },
    { title: '측정값', key: 'measuredValue', scopedSlots: { customRender: 'measuredValue' } },
    { title: '측정자', key: 'measuredBy', scopedSlots: { customRender: 'measuredBy' } },
    { title: '교환번호', key: 'exchangeNo', scopedSlots: { customRender: 'exchangeNo' } },
    { title: '결과', key: 'result', scopedSlots: { customRender: 'result' }, width: 100 },
];

const measurementWorkColumns = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 60 },
    { title: '분류', dataIndex: 'category', key: 'category' },
    { title: '장비명', dataIndex: 'equipmentName', key: 'equipmentName' },
    { title: '점검항목', dataIndex: 'checkItem', key: 'checkItem' },
    { title: '기준', dataIndex: 'standard', key: 'standard' },
    { title: '단위', dataIndex: 'unit', key: 'unit', width: 80 },
    { title: '측정값', key: 'measuredValue', scopedSlots: { customRender: 'measuredValue' } },
    { title: '결과', key: 'result', scopedSlots: { customRender: 'result' }, width: 100 },
    { key: 'inspector', slots: { title: 'inspectorHeader' }, scopedSlots: { customRender: 'inspector' } },
    { title: '메모', key: 'memo', scopedSlots: { customRender: 'memo' } },
];

const GAS_FILLING_CATEGORY = 'GAS 충진 M/C';
const GAS_FILLING_TARGETS = ['제습기', '정수기'];
const GAS_FILLING_SHIFTS = ['오전', '오후', '잔업'];

const gasFillingWorkColumns = [
    { title: '구분', dataIndex: 'shift', key: 'shift', width: 80 },
    { title: '레온 압력', key: 'freonPressure', scopedSlots: { customRender: 'freonPressure' } },
    { title: '진공도', key: 'vacuumLevel', scopedSlots: { customRender: 'vacuumLevel' } },
    { title: '프레온 온도', key: 'freonTemperature', scopedSlots: { customRender: 'freonTemperature' } },
    { title: '셋팅', key: 'settingValue', scopedSlots: { customRender: 'settingValue' } },
    { title: '충진량', key: 'chargeAmount', scopedSlots: { customRender: 'chargeAmount' } },
    { title: '점검결과', key: 'checkResult', scopedSlots: { customRender: 'checkResult' }, width: 140 },
];

const gasSaverWorkColumns = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 60 },
    { title: '관리번호', dataIndex: 'managementNo', key: 'managementNo' },
    { title: '점검항목', dataIndex: 'checkItem', key: 'checkItem' },
    { title: '기준', dataIndex: 'standard', key: 'standard' },
    { title: '측정값', key: 'measuredValue', scopedSlots: { customRender: 'measuredValue' } },
    { title: '결과', key: 'result', scopedSlots: { customRender: 'result' }, width: 100 },
];

const inspectionWorkColumns = [
    { title: 'No', key: 'no', scopedSlots: { customRender: 'no' }, width: 60 },
    { title: '장비명', dataIndex: 'equipmentName', key: 'equipmentName' },
    { title: '점검항목', dataIndex: 'checkItem', key: 'checkItem' },
    { title: '기준', dataIndex: 'standard', key: 'standard' },
    { title: '결과', key: 'result', scopedSlots: { customRender: 'result' }, width: 100 },
];

export default {
    name: 'ToolWorkSheet',
    components: {
        PageHeader,
        DatePicker,
    },
    data() {
        return {
            columns,
            columns2,
            driverTorqueWorkColumns,
            measurementWorkColumns,
            gasFillingWorkColumns,
            gasSaverWorkColumns,
            inspectionWorkColumns,
            workingData: [],
            completedData: [],
            workingCount: 0,
            completedCount: 0,
            templateList: [],
            selectedTemplate: null,
            autoFillInspector: false,
            filterCS: '',
            filterField: '라인명',
            filterDateStartCS: '',
            filterDateEndCS: '',
            pagination: {
                current: 1,
                pageSize: 10,
                total: 0,
                showSizeChanger: true,
                showTotal: (total, range) => `${range[0]}-${range[1]} / ${total}개`
            },
            managerList: [],
            flagForDrawer: false,
            currentEditKey: null,
            formData: {
                basicInfo: {
                    date: '',
                    lineName: '',
                    writer: '',
                    productModel: ''
                },
                driverTorque: [],
                measurement: [],
                gasFilling: [],
                gasSaver: [],
                inspection: []
            }
        };
    },
    mounted() {
        this.fetchTemplateList();
        this.fetchWorkSheetList();
        this.fetchManagerList();
    },
    methods: {
        fetchManagerList() {
            this.$http.get(this.$store.state.nodeApiUrl + '/manager/list').then(res => {
                if (res.data && res.data.code === 'success') {
                    this.managerList = res.data.data;
                }
            }).catch(() => {});
        },
        onAutoFillInspectorChange(e) {
            if (e.target.checked && this.formData.measurement.length > 0) {
                const firstName = this.formData.measurement[0].inspector || '';
                this.formData.measurement.forEach(row => { row.inspector = firstName; });
            }
        },
        onInspectorInput(index) {
            if (index === 0 && this.autoFillInspector && this.formData.measurement.length > 1) {
                const firstName = this.formData.measurement[0].inspector || '';
                this.formData.measurement.forEach((row, i) => {
                    if (i > 0) row.inspector = firstName;
                });
            }
        },
        createGasFillingRows() {
            return GAS_FILLING_SHIFTS.map(shift => ({
                shift,
                freonPressure: '',
                vacuumLevel: '',
                freonTemperature: '',
                settingValue: '',
                chargeAmount: '',
                checkResult: '',
            }));
        },
        ensureGasSection(target) {
            let section = this.formData.gasFilling.find(item => item.target === target);
            if (!section) {
                section = { target, swStatus: '', rows: this.createGasFillingRows() };
                this.formData.gasFilling.push(section);
            }
            return section;
        },
        applyGasSectionSwStatus(section, shift, memo, parsedValue) {
            const sw = memo || (parsedValue && parsedValue.swStatus) || '';
            if (!sw) return;
            if (shift === '오전' || !section.swStatus) {
                section.swStatus = sw;
            }
        },
        parseGasMeasuredValue(rawValue) {
            if (!rawValue) return {};
            if (typeof rawValue === 'object') return rawValue;
            try {
                return JSON.parse(rawValue);
            } catch (e) {
                return {};
            }
        },
        loadGasRowFromItem(gasRow, item) {
            const raw = item.measuredValue != null ? String(item.measuredValue).trim() : '';
            if (raw.startsWith('{')) {
                const parsed = this.parseGasMeasuredValue(raw);
                gasRow.freonPressure = parsed.freonPressure || '';
                gasRow.vacuumLevel = parsed.vacuumLevel || '';
                gasRow.freonTemperature = parsed.freonTemperature || '';
                gasRow.settingValue = parsed.settingValue || '';
                gasRow.chargeAmount = parsed.chargeAmount || '';
            } else {
                gasRow.freonPressure = item.measuredValue || '';
                gasRow.vacuumLevel = item.standard || '';
                gasRow.freonTemperature = item.unit || '';
                gasRow.settingValue = item.measuredBy || '';
                gasRow.chargeAmount = item.exchangeNo || '';
            }
            gasRow.checkResult = item.result || '';
        },
        fetchTemplateList() {
            this.$http.get(`${this.$store.state.nodeApiUrl}/tool/template/list?size=100&page=0&state=TL_B`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.templateList = response.data.data.content.map(item => ({
                            id: item.productCsSeq,
                            name: item.name
                        }));
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        fetchWorkSheetList() {
            const page = this.pagination.current - 1;
            const size = this.pagination.pageSize;
            
            let urlWorking = `${this.$store.state.nodeApiUrl}/tool/worksheet/list?size=100&page=0&state=TL_C`;
            let urlCompleted = `${this.$store.state.nodeApiUrl}/tool/worksheet/list?size=${size}&page=${page}&state=TL_D`;
            
            this.$http.get(urlWorking)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.workingData = response.data.data.content.map(item => ({
                            key: item.productCsSeq,
                            tags: ['작성중'],
                            lineName: item.line,
                            productModel: item.productModel || '-',
                            writer: item.manager,
                            updated: item.updated
                        }));
                        this.workingCount = this.workingData.length;
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
            
            this.$http.get(urlCompleted)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.pagination.total = response.data.data.totalElements || 0;
                        this.completedData = response.data.data.content.map(item => ({
                            key: item.productCsSeq,
                            tags: ['작성완료'],
                            lineName: item.line,
                            productModel: item.productModel || '-',
                            writer: item.manager,
                            date: item.updated ? item.updated.split(' ')[0] : '',
                            updated: item.updated
                        }));
                        this.completedCount = response.data.data.totalElements;
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        loadTemplate() {
            if (!this.selectedTemplate) {
                this.$message.error('템플릿을 선택해주세요');
                return;
            }
            
            const postData = {
                lineName: '',
                writer: '',
                creator: sessionStorage.getItem('user_name') || 'system',
                updater: sessionStorage.getItem('user_name') || 'system'
            };
            
            this.$http.post(`${this.$store.state.nodeApiUrl}/tool/worksheet/copy/${this.selectedTemplate}`, postData)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.$message.success('템플릿을 불러왔습니다.');
                        this.selectedTemplate = null;
                        this.fetchWorkSheetList();
                        const newSeq = response.data.data && response.data.data.productCsSeq;
                        if (newSeq) this.handlerToEdit(newSeq);
                    } else {
                        this.$message.error('템플릿 불러오기에 실패했습니다.');
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('템플릿 불러오기에 실패했습니다.');
                });
        },
        filterCSList() {
            console.log('Filter:', this.filterField, this.filterCS);
            // TODO: 필터링 로직
        },
        resetCSList() {
            this.filterCS = '';
            this.filterDateStartCS = '';
            this.filterDateEndCS = '';
            this.fetchWorkSheetList();
        },
        handleTableChange(pagination) {
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.fetchWorkSheetList();
        },
        handlerToEdit(key) {
            this.$http.get(`${this.$store.state.nodeApiUrl}/tool/template/item/${key}`)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        const data = response.data.data;
                        this.currentEditKey = key;
                        this.formData.basicInfo.date = data.created || '';
                        this.formData.basicInfo.lineName = data.line;
                        this.formData.basicInfo.writer = data.manager;
                        this.formData.basicInfo.productModel = data.productModel || '';
                        
                        this.formData.driverTorque = [];
                        this.formData.measurement = [];
                        this.formData.gasFilling = [];
                        this.formData.gasSaver = [];
                        this.formData.inspection = [];
                        
                        data.items.forEach(item => {
                            if (item.category === 'driver_torque') {
                                this.formData.driverTorque.push({
                                    processName: item.processName,
                                    toolType: item.toolType,
                                    managementNo: item.managementNo,
                                    standard: item.standard,
                                    measuredValue: item.measuredValue || '',
                                    measuredBy: item.measuredBy || '',
                                    exchangeNo: item.exchangeNo || '',
                                    result: item.result || ''
                                });
                            } else if (item.category === 'measurement') {
                                if (
                                    item.categoryName === GAS_FILLING_CATEGORY &&
                                    GAS_FILLING_TARGETS.includes(item.equipmentName)
                                ) {
                                    const section = this.ensureGasSection(item.equipmentName);
                                    const gasRow = section.rows.find(row => row.shift === item.checkItem);
                                    if (gasRow) {
                                        this.loadGasRowFromItem(gasRow, item);
                                        this.applyGasSectionSwStatus(
                                            section,
                                            item.checkItem,
                                            item.memo,
                                            null
                                        );
                                    }
                                    return;
                                }
                                this.formData.measurement.push({
                                    category: item.categoryName,
                                    equipmentName: item.equipmentName,
                                    checkItem: item.checkItem,
                                    standard: item.standard,
                                    unit: item.unit,
                                    measuredValue: item.measuredValue || '',
                                    result: item.result || '',
                                    inspector: item.inspector || '',
                                    memo: item.memo || ''
                                });
                            } else if (item.category === 'gas_saver') {
                                this.formData.gasSaver.push({
                                    managementNo: item.managementNo,
                                    checkItem: item.checkItem,
                                    standard: item.standard,
                                    measuredValue: item.measuredValue || '',
                                    result: item.result || ''
                                });
                            } else if (item.category === 'inspection') {
                                this.formData.inspection.push({
                                    equipmentName: item.equipmentName,
                                    checkItem: item.checkItem,
                                    standard: item.standard,
                                    result: item.result || ''
                                });
                            }
                        });
                        
                        this.flagForDrawer = true;
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.$message.error('데이터 조회에 실패했습니다.');
                });
        },
        handlerToDelete(key) {
            this.$confirm({
                title: '삭제 확인',
                content: '정말 삭제하시겠습니까?',
                onOk: () => {
                    this.$http.delete(`${this.$store.state.nodeApiUrl}/tool/template/delete/${key}`)
                        .then((response) => {
                            if (response.status === 200 && response.data.code === 'success') {
                                this.$message.success('삭제되었습니다.');
                                this.fetchWorkSheetList();
                            }
                        })
                        .catch((error) => {
                            console.error(error);
                            this.$message.error('삭제에 실패했습니다.');
                        });
                }
            });
        },
        handlerForCloseDrawer() {
            this.flagForDrawer = false;
            this.currentEditKey = null;
        },
        handleSaveTemp() {
            this.saveWorkSheet('TL_C');
        },
        handleSaveComplete() {
            this.saveWorkSheet('TL_D');
        },
        saveWorkSheet(state) {
            if (!this.currentEditKey) {
                this.$message.error('저장할 항목을 선택해주세요.');
                return;
            }
            
            const items = [];
            
            this.formData.driverTorque.forEach(item => {
                items.push({
                    category: 'driver_torque',
                    processName: item.processName,
                    toolType: item.toolType,
                    managementNo: item.managementNo,
                    standard: item.standard,
                    measuredValue: item.measuredValue,
                    measuredBy: item.measuredBy,
                    exchangeNo: item.exchangeNo,
                    result: item.result
                });
            });
            
            this.formData.measurement.forEach(item => {
                items.push({
                    category: 'measurement',
                    categoryName: item.category,
                    equipmentName: item.equipmentName,
                    checkItem: item.checkItem,
                    standard: item.standard,
                    unit: item.unit,
                    measuredValue: item.measuredValue,
                    result: item.result,
                    inspector: item.inspector,
                    memo: item.memo
                });
            });

            this.formData.gasFilling.forEach(section => {
                section.rows.forEach(row => {
                    items.push({
                        category: 'measurement',
                        categoryName: GAS_FILLING_CATEGORY,
                        equipmentName: section.target,
                        checkItem: row.shift,
                        measuredValue: row.freonPressure || '',
                        standard: row.vacuumLevel || '',
                        unit: row.freonTemperature || '',
                        measuredBy: row.settingValue || '',
                        exchangeNo: row.chargeAmount || '',
                        result: row.checkResult,
                        memo: row.shift === '오전' ? (section.swStatus || '') : '',
                    });
                });
            });
            
            this.formData.gasSaver.forEach(item => {
                items.push({
                    category: 'gas_saver',
                    managementNo: item.managementNo,
                    checkItem: item.checkItem,
                    standard: item.standard,
                    measuredValue: item.measuredValue,
                    result: item.result
                });
            });
            
            this.formData.inspection.forEach(item => {
                items.push({
                    category: 'inspection',
                    equipmentName: item.equipmentName,
                    checkItem: item.checkItem,
                    standard: item.standard,
                    result: item.result
                });
            });
            
            const postData = {
                name: '치공구 점검 일지',
                state: state,
                lineName: this.formData.basicInfo.lineName,
                writer: this.formData.basicInfo.writer,
                updater: sessionStorage.getItem('user_name') || 'system',
                items: items
            };
            
            this.$http.put(`${this.$store.state.nodeApiUrl}/tool/template/update/${this.currentEditKey}`, postData)
                .then((response) => {
                    if (response.status === 200 && response.data.code === 'success') {
                        this.$message.success(state === 'TL_C' ? '임시저장되었습니다.' : '작성완료되었습니다.');
                        this.handlerForCloseDrawer();
                        this.fetchWorkSheetList();
                    } else {
                        this.$message.error('저장에 실패했습니다: ' + (response.data.message || '알 수 없는 오류'));
                    }
                })
                .catch((error) => {
                    console.error(error);
                    const msg = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : '저장에 실패했습니다.';
                    this.$message.error(msg);
                });
        }
    }
};
</script>

<style scoped>
.state-btn {
    font-weight: bold;
    padding: 2px 8px;
}
.state-btn.red {
    background-color: #ff4d4f;
    color: white;
}
.state-btn.green {
    background-color: #52c41a;
    color: white;
}
.div_action {
    text-align: right;
}
</style>
